import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import cx from 'classnames';
import { CatCard } from '@blocks-react/components/Card';
import { CatIconChevronRight } from '@blocks-react/components/Icons/ChevronRight';
import { CatIconArrowForward } from '@blocks-react/components/Icons/ArrowForward';
import { CatHeading } from '@blocks-react/components/Heading';
import styles from './FooterButton.module.scss';
import { CatIconSearch } from '@blocks-react/components/Icons/Search';
import { CatIconHelp } from '@blocks-react/components/Icons/Help';
import { CatIconPerson } from 'blocks-nextjs/blocks-react/components/Icons/Person';
import { CatIconPeople } from 'blocks-nextjs/blocks-react/components/Icons/People';
import { CatIconLanguage } from 'blocks-nextjs/blocks-react/components/Icons/Language';
import { CatIconGrid } from 'blocks-nextjs/blocks-react/components/Icons/Grid';
var iconType;
(function (iconType) {
    iconType["SEARCH"] = "CatIconSearch";
    iconType["HELP"] = "CatIconHelp";
    iconType["PERSON"] = "CatIconPerson";
    iconType["PEOPLE"] = "CatIconPeople";
    iconType["LANGUAGE"] = "CatIconLanguage";
    iconType["GRID"] = "CatIconGrid";
})(iconType || (iconType = {}));
export const FooterButton = ({ title, icon, children, onClick }) => {
    const iconSize = 'lg';
    const iconColor = 'knockout-brand';
    const getIcon = () => {
        switch (icon) {
            case iconType.SEARCH:
                return _jsx(CatIconSearch, { color: iconColor, size: iconSize });
            case iconType.HELP:
                return _jsx(CatIconHelp, { color: iconColor, size: iconSize });
            case iconType.PERSON:
                return _jsx(CatIconPerson, { color: iconColor, size: iconSize });
            case iconType.PEOPLE:
                return _jsx(CatIconPeople, { color: iconColor, size: iconSize });
            case iconType.LANGUAGE:
                return _jsx(CatIconLanguage, { color: iconColor, size: iconSize });
            case iconType.GRID:
                return _jsx(CatIconGrid, { color: iconColor, size: iconSize });
            default:
                return _jsx(CatIconSearch, { color: iconColor, size: iconSize });
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(CatCard, { "data-testId": "footer-button-mobile", className: cx(styles['footer_Button']), onClick: onClick, children: _jsxs("div", { className: "d-flex gap-3 align-items-center align-items-md-start py-lg-2", children: [getIcon(), _jsx("div", { className: "d-flex flex-md-column flex-grow-1 flex-lg-grow-0 justify-content-between align-items-center gap-1 ", children: _jsxs("div", { className: "d-flex w-100 justify-content-between gap-2 align-items-center align-items-md-start", children: [_jsx(CatHeading, { level: "h3", variant: "title-sm", color: "knockout", className: "text-center d-block", children: title }), _jsx("div", { className: "d-block d-lg-none", children: _jsx(CatIconChevronRight, { color: "knockout-brand" }) }), _jsx("div", { className: cx('d-none d-lg-block position-absolute', styles['arrow_upward']), children: _jsx(CatIconArrowForward, {}) })] }) })] }) }), _jsx("ul", { className: styles['footer__list'], children: children })] }));
};
